export default 'Expand {0}';